import * as React from "react";

function PrimaryButton1() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="68" height="21" viewBox="0 0 68 21">
    <g id="Primary_Button" data-name="Primary Button" transform="translate(19 7)">
      <rect id="Rectangle_8874" data-name="Rectangle 8874" width="68" height="21" rx="2" transform="translate(-19 -7)" fill="#2067ed"/>
      <text id="Primary_Button-2" data-name="Primary Button" transform="translate(-11 6)" fill="#fff" font-size="7" font-family="OpenSans-Semibold, Open Sans" font-weight="600"><tspan x="0" y="0">Primary Button</tspan></text>
    </g>
  </svg>

  );
}

export default PrimaryButton1;
